import React from 'react';
import {
  View,
  Text,
  Platform,
} from 'react-native';
import {
  Button,
} from 'react-native-elements';

import styles from '../../styles';
import { translate } from '../../locales/i18n';

export default {
  id: 'none',
  name: 'revenue_method_none',
  comment: 'revenue_method_none_comment',
  configure: (dismiss, select) => (_props, _context) => (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Text>
        {translate('revenue_method_none_info')}
      </Text>
      <View style={{
        backgroundColor: 'white',
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'row',
        marginTop: 40,
        ...(Platform.OS === 'ios' ? {
          paddingBottom: 10,
        } : {}),
      }}
      >
        <Button
          title={translate('button_cancel')}
          containerStyle={styles.button.secondaryContainer}
          buttonStyle={styles.button.secondary}
          titleStyle={styles.button.secondaryTitle}
          onPress={dismiss}
        />
        <Button
          title={translate('button_select')}
          containerStyle={styles.button.primaryContainer}
          buttonStyle={styles.button.primary}
          titleStyle={styles.button.primaryTitle}
          onPress={() => {
            select({
              payout: 'none',
            });
          }}
          loadingProps={{ size: 'small', color: 'white' }}
        />
      </View>
    </View>
  ),
};
